<template>
  <div>
    <div class="container flex flex__justify-space-between">
      <div class="left">
        <div class="chart-left-1">{{ $t("home.gpbUsd.title") }}</div>
        <div class="chart-left-2">
          <img src="../../../assets/image/logo/dbg_logo241113_bb.svg" alt="">
          <img src="../../../assets/image/icon/leftArrow.svg" alt="">
        </div>
        <p>
          {{ $t('home.gpbUsd.service') }}
        </p>
        <!-- <div class="btn-group">
          <button class="btn btn-primary" style="min-width: 136px;font-size: 13px;"
            @click="$open('signUp', $i18n.locale)">
            {{ $t('common.registerNow') }}
          </button>
          <button class="btn btn-primary" style="min-width: 136px;font-size: 13px;"
            @click="$open('signUp5', $i18n.locale)">
            {{ $t('common.registerNow5') }}
          </button>
        </div> -->
      </div>
      <div class="right">
        <gpb-chart></gpb-chart>
      </div>
    </div>
  </div>
</template>

<script>
import GpbChart from './gpb-chart'
export default {
  name: 'gpb-usd',

  components: {
    GpbChart,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  methods: {
  },
}
</script>

<style scoped lang="scss">
.container {
  margin-top: 80px;
  margin-bottom: 100px;
  column-gap: 24px;

  .left {
    width: 276px;

    .chart-left {
      width: 193px;
      height: 112px;
      background-size: 100%;
      background-repeat: no-repeat;
      margin-top: 33px;
      line-height: 40px;
      font-size: 30px;
      font-weight: bolder;
      color: #0D73D6;
      // @include bg-image('../../../assets/image/home/chart-left')
    }

    .chart-left-1 {
      line-height: 62px;
      font-size: 44px;
      font-weight: bolder;
      color: #0D73D6;
      margin-bottom: 10px;
    }

    .chart-left-2 {
      display: flex;
      align-items: center;
      column-gap: 16px;

      &-logo {
        width: 91px;
        height: 40px;
      }

      &-left-arrow {
        width: 16px;
        height: 16px;
      }
    }

    p {
      color: #000;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, .6);
      line-height: 26px;
      margin-top: 32px;
      /*word-break: break-all;*/
      word-wrap: break-word;
    }

    .btn-group {
      display: flex;

      .btn {
        white-space: nowrap;
        padding: 0 4px;
        margin-right: 4px;
      }
    }
  }

  .right {
    box-shadow: 0px 0px 20px 0px rgba(33, 66, 171, 0.15);
  }
}
</style>
